import script from "./VoicePop.vue?vue&type=script&setup=true&lang=js"
export * from "./VoicePop.vue?vue&type=script&setup=true&lang=js"

import "./VoicePop.vue?vue&type=style&index=0&id=546d5539&scoped=true&lang=css"
import "./VoicePop.vue?vue&type=style&index=1&id=546d5539&scoped=true&lang=css"

import exportComponent from "/root/workspace/webFrontEnd_cs-mail-comment_sZq3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-546d5539"]])

export default __exports__